import React, { Component } from 'react'
import CollectionList from '../collection-list'
import CollectionTitles from '../collection-titles'

// Case studies component wraps the common
// collection rows component to display 
// rows of collection slides 
// Consider - background canvas row - also not part of this?
class Collection extends Component {

  componentDidMount() {
    this.requestRows()
  }

  // Check for scrollEnd changes 
  // Begin timeout to navigate back one on complete
  componentWillReceiveProps(nextProps) {

    // Check if collection has exited completely
    // And clear rows if so 
    const {
      pageExitComplete: prevPageExitComplete
    } = this.props
    const {
      pageExitComplete: nextPageExitComplete
    } = nextProps

    if (prevPageExitComplete !== nextPageExitComplete) {
      if (nextPageExitComplete) {
        const { onClearRows } = this.props
        onClearRows && onClearRows()
      }
    }

    if (!nextProps.active) {
      return
    }
    if (nextProps.scrollEnd !== this.props.scrollEnd) {
      this.clearNavigateTimeout()
      if (nextProps.scrollEnd) {
        this.startNavigateTimeout()
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active === this.props.active) return
    this.requestRows()
  }

  componentWillUnmount() {
    this.clearNavigateTimeout()
  }

  clearNavigateTimeout() {
    if (this.navTimeout) {
      clearTimeout(this.navTimeout)
      this.navTimeout = null
    }
  }

  startNavigateTimeout() {
    this.navTimeout = setTimeout(this.handleNavigateTimeout, 1000)
  }

  handleNavigateTimeout = () => {
    const { onNavigate } = this.props
    onNavigate && onNavigate()
  }

  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestRows() {
    const { rows, requestId, id, active, onRequestRows } = this.props

    if (rows && (id === requestId)) return
    if (!active) return
    
    onRequestRows && onRequestRows(id)
  }

  render() {
    const { match } = this.props 

    let isSubCollection = false
    if (match) {
      if (match.params && match.params.artistId) {
        isSubCollection = true
      }
    }
    
    return (
      <div className="collection">
        <CollectionList {...this.props} />
        <CollectionTitles disabled={isSubCollection} artist={true} page={true} visible={true} {...this.props} />
      </div>
    )
  }
}

export default Collection



// WEBPACK FOOTER //
// ./src/components/collection-container/collection.js